@if (dialogData?.showXBtn) {
    <mine-x-button data-cy="dialog__x-btn" (onClick)="cancelClicked()">
    </mine-x-button>
}

@if (dialogData?.image) {
    <img class="mine-title-m dialog__image" data-cy="dialog__image" [src]="dialogData?.image"
        [width]="dialogData?.imageWidth ?? 150" />
}

<div class="mine-title-m dialog__title" data-cy="dialog__title" [class.dialog__title--margin-bottom]="!dialogData?.text"
    [innerHTML]="dialogData?.title | safe">
</div>

@if (dialogData?.text) {
    <div class="dialog__text" data-cy="dialog__text" [innerHTML]="dialogData?.text | safe">
    </div>
}

<div class="dialog__buttons">
    @if (dialogData?.cancelBtn) {
        <button mine-button color="secondary" class="dialog__cancel-btn" data-cy="dialog__cancel-btn"
            (click)="cancelClicked()">
            {{dialogData?.cancelBtn}}
        </button>
    }
    @if (dialogData?.okBtn) {
        <mine-button-primary class="dialog__ok-btn" data-cy="dialog__ok-btn" [text]="dialogData?.okBtn"
            [theme]="okButtonTheme" (onClick)="okClicked()">
        </mine-button-primary>
    }
</div>